import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import ArgoTextFieldSelectHook from "./ArgoTextFieldSelectHook";
import * as metadataUtils from "../../utilities/metadata";
import * as portalShared from "../../portal/shared/metadataConstantsAndUtilities"
import * as TEMPLATE from "../../constants/templateConstants";

const ArgoSelectPortalTextDisplayTypeHook = (props) => {
    const {
        initTo,
        templateType,
        textEntryType,
        fieldTextObjName,
        fieldName,
        metadataPropsObj,
        useMetadataPropsObjAltFunction,
        questionDepth,
        setStateFormatObj,
        hideOption,
        hideOnly,
        index,
        labelText,
        width
    } = props;

    const [textDisplay, setTextDisplay] = useState(initTo);

    // componentWillReceiveProps equivalent
    useEffect(() => {
        setTextDisplay(initTo);
    }, [initTo]);

    const onSelectChange = useCallback((event) => {

        const selected = event.target.value;
        let metadataValue = "";

        switch(selected) {
            case "hide":
                metadataValue = selected;
                break;
            case "default":
            case "custom":
            case "pageNum":
            case "pageofNum":
                metadataValue = JSON.stringify(portalShared.getCustomTextObj(templateType, textEntryType, selected));
                break;
            default:
                console.log("ArgoSelectPortalTextDisplayTypeHook.js Switch default E01"); // eslint-disable-line
        }

        let mpo = metadataPropsObj;
        if (useMetadataPropsObjAltFunction) {
            mpo.setStateCallbackFunction = mpo.setCustomMetadataFunctionAlt;
        }

        if (textEntryType === TEMPLATE.TEXT_TYPE.QUESTION.LABEL) {
            let customObj = JSON.parse(mpo.template.metadata[mpo.metadataTag]);
            customObj.labelDisplay = selected;
            let updatedTemplate = portalShared.cloneObj(mpo.template);
            updatedTemplate.metadata[mpo.metadataTag] = JSON.stringify(customObj);

            if ((selected === "default")) {
                if (updatedTemplate.metadata.hasOwnProperty(portalShared.CUSTOM_DDO_QUE_LABEL)) {
                    delete updatedTemplate.metadata[portalShared.CUSTOM_DDO_QUE_LABEL];
                }
            } else {
                updatedTemplate.metadata[portalShared.CUSTOM_DDO_QUE_LABEL] = JSON.stringify(portalShared.getCustomQuestionLabelTextObj());
                mpo.templateUpdateFunction(updatedTemplate, questionDepth);
            }

            setTextDisplay(selected);
            if (setStateFormatObj) {
                setStateFormatObj(customObj);
            }
        } else {
            setTextDisplay(selected);
            metadataUtils.setCustomMetadata(
                fieldTextObjName,
                mpo.template, 
                mpo.templateUpdateFunction, 
                mpo.setStateCallbackFunction, 
                fieldName, 
                selected, 
                mpo.metadataTag, 
                (metadataValue !== "hide" ? JSON.parse(metadataValue) : "hide"), 
                mpo.depth
            );
        }
    }, [templateType, textEntryType, metadataPropsObj, useMetadataPropsObjAltFunction, questionDepth, setStateFormatObj, fieldTextObjName, fieldName]);

    const textDisplayItems = [];

    if (hideOption) {
        textDisplayItems.push({value: "hide", text: "Hide"});
    }

    if (!hideOnly) {
        textDisplayItems.push({value: "default", text: "Default"});
        textDisplayItems.push({value: "custom", text: "Custom"});
    }

    if (textEntryType === TEMPLATE.TEXT_TYPE.CATEGORY.HEADER_LEFT ||
        textEntryType === TEMPLATE.TEXT_TYPE.CATEGORY.HEADER_CENTER ||
        textEntryType === TEMPLATE.TEXT_TYPE.CATEGORY.HEADER_RIGHT)
    {
        textDisplayItems.push({value: "pageNum", text: "Page X"});
        textDisplayItems.push({value: "pageofNum", text: "Page X of Y"});
    }

    return (
        <React.Fragment>
            <div style={{width: "15px"}}></div>

            <ArgoTextFieldSelectHook
                fileName="ArgoSelectPortalTextDisplayTypeHook"
                fieldName="textDisplay"
                index={index}
                label={labelText}
                value={hideOnly ? "hide" : textDisplay}
                onChange={onSelectChange}
                fullWidth={false}
                width={width}
                menuItems={textDisplayItems}
                disabled={hideOnly}
            />
        </React.Fragment>
    );
};

ArgoSelectPortalTextDisplayTypeHook.defaultProps = {
    labelText: "Portal Display",
    hideOption: true,
    hideOnly: false,
    index: 0,
    questionDepth: 0,
    width: "130px"
};

ArgoSelectPortalTextDisplayTypeHook.propTypes = {
    templateType: PropTypes.string,
    textEntryType: PropTypes.string,
    fieldName: PropTypes.string,
    fieldTextObjName: PropTypes.string,
    labelText: PropTypes.string,
    hideOption: PropTypes.bool,
    hideOnly: PropTypes.bool,
    initTo: PropTypes.string,
    metadataPropsObj: PropTypes.object,
    index: PropTypes.number,
    questionDepth: PropTypes.number,
    setStateFormatObj: PropTypes.func,
    width: PropTypes.string
};

export default ArgoSelectPortalTextDisplayTypeHook;
